<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';

// Eagerly fetch /api/me on app boot. If the cookie is valid the user lands
// straight on /dashboard; otherwise the router guard redirects to /login.
const auth = useAuthStore();
onMounted(() => auth.fetchMe());
</script>

<template>
  <RouterView />
</template>
